import React, { useState, useEffect } from 'react';
import Step1New from './propertyForm/step1New';
import Step2Details from './propertyForm/Step2Details';
import Step3Medias from './propertyForm/Step3Medias';
import Step4Features from './propertyForm/Step4Features';
import Step5Preview from './propertyForm/Step5Preview';
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import Notification, { showToast } from '../../../components/common/notification/Notification';
import { useNavigate } from "react-router-dom";

const EditPropertyItem = () => {
  const navigate = useNavigate();
  
  const loggedInUser = useSelector((state) => state.auth.user);
  // const token = loggedInUser?.token;
  const token = loggedInUser?.refreshToken;
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const assetUrl = process.env.REACT_APP_ASSET_URL;
  const { Id } = useParams();

  const [step, setStep] = useState(1);
  const [propertyForm, setPropertyForm] = useState({});
  const steps = ['New', 'Details', 'Medias', 'Features', 'Preview'];

  useEffect(() => {
    const fetchProperty = async () => {
      try { 
        const response = await axios.get(`${baseUrl}/property/propertyDetail/${Id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const property = response.data.propertyInfo;
        console.log('res', property) 

        setPropertyForm({
          city: property.city.id || "",
          cityName: property.city.name || "",
          state: property.state.id || "",
          stateName: property.state.name || "",
          area: property.area_name || "",
          propertyType: property.type.id || "",
          propertyPurpose: property.purpose.id || "",
          propertyStatus: property.status.id || "",
          propertySubtype: property.property_sub_type.id || "",
          propertySubSubType: property.property_sub_sub_type?.id || "",
          structure: property.structure || {},
          feature: property.feature || {}, 
          images: property.images
            ? property.images.map(img => ({
                ...img,
                url: assetUrl + img.image_url,
              }))
            : [],
          videos: property.videos
            ? property.videos.map(video => ({
                ...video,
                url: assetUrl + video.url_path,
              }))
            : [],
          attachments: property.attachments
            ? property.attachments.map(att => ({
                ...att,
                url: assetUrl + att.attachment_url,
              }))
            : [], 
          tags: property.tags || "",
          name: property.name || "",
          description: property.description || "",
          address: property.address || "",
          land_mark: property.land_mark || "",
          pin_code: property.pin_code || "",
          price: property.price || "",
          landType: property.landType.id || "",
          are: property.are || "", 
          loanAvailability: property.loan_availability || false,
          featured_property: property.featured_property, 
        });
        console.log('propertyForm', propertyForm)
      } catch (error) {
        console.error("Failed to fetch property:", error);
      }
    };

    fetchProperty();
  }, [Id, assetUrl, baseUrl, token]);

  const handleNext = () => step < steps.length && setStep(step + 1);
  const handleBack = () => step > 1 && setStep(step - 1);
  const handleUpdate = () => setStep(1);

const handleSubmit = async () => {
  const images = (propertyForm.images || []).map((img) => ({
    imagePath: img.name || img.imagePath || "",
    // image_url: (img.url || "").replace(assetUrl, ""),
  }));

  const attachments = (propertyForm.attachments || []).map((attachment) => ({
    attachmentPath: attachment.name || attachment.attachmentPath || "",
    // attachment_url: (attachment.url || "").replace(assetUrl, ""),
  }));

  const videos = [{}];
  // const videos = (propertyForm.videos || []).map((video) => ({
  //   videoPath: video.name || video.videoPath || "",
  //   // url_path: (video.url || "").replace(assetUrl, ""),
  // }));

  const payload = {
    // title to be changed to name 
    // are gets null
    // budget gets null and better change it to price
    name: propertyForm.name || "",
    are: propertyForm.are || "",
    price: propertyForm.price || "",

    
    id: propertyForm.id || parseInt(Id),
    title: propertyForm.name || "", 
    description: propertyForm.description || "",
    budget: propertyForm.price || "", 
    purpose_id: propertyForm.propertyPurpose || null,
    type_id: propertyForm.propertyType || null,
    sub_type_id: propertyForm.propertySubtype || null,
    sub_sub_type_id: propertyForm.propertySubSubType || null,
    featured_property: propertyForm.featured_property,
    city_name: propertyForm.cityName || "",
    state_name: propertyForm.stateName || "", 
    country_name: "India",
    area_name: propertyForm.area || "", 
    property_status_id: propertyForm.propertyStatus || 1,
    // structure: { id: propertyForm.structure.id || "" },
    structure: { id: parseInt(Id) || "" },
    // feature: { id: propertyForm.feature.id || "" },
    feature: { id: parseInt(Id) || "" },
    images,
    attachments,
    videos,
    tags: propertyForm.tags || "",
    address: propertyForm.address || "",
    land_mark: propertyForm.land_mark || "",
    pin_code: propertyForm.pin_code || "",
    land_type_id: propertyForm.landType, 
    loan_availability: propertyForm.loanAvailability,
    are: propertyForm.are,
  };
  console.log('payload', payload)
  try {
    const response = await axios.put(`${baseUrl}/property/editProperty`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 200 && response.data.statusType === 'SUCCESS') {
      showToast('Property edited successfully' , { type: 'success' });
      setTimeout(() => {
        navigate("/property");
      }, 2000);
    } else {
      showToast('Failed to edit Property data', { type: 'error' });
    }
    console.log("Response:", response.data);
  } catch (error) {
    showToast('Failed to edit Property data', { type: 'error' });
    console.error("Error updating property:", error);
  }
};

  const renderStepComponent = () => {
    switch (step) {
      case 1:
        return <Step1New form={propertyForm} setForm={setPropertyForm} nextStep={handleNext} />;
      case 2:
        return <Step2Details form={propertyForm} setForm={setPropertyForm} nextStep={handleNext} prevStep={handleBack} />;
      case 3:
        return <Step3Medias form={propertyForm} setForm={setPropertyForm} nextStep={handleNext} prevStep={handleBack} />;
      case 4:
        return <Step4Features form={propertyForm} setForm={setPropertyForm} nextStep={handleNext} prevStep={handleBack} />;
      case 5:
        return (
          <>
            {/* <Notification /> */}
            <Step5Preview
              form={propertyForm}
              prevStep={handleBack}
              onUpdate={handleUpdate}
              onSubmit={handleSubmit}
            />
          </>
          
        );
      default:
        return null;
    }
  };

  const progressPercent = ((step - 1) / (steps.length - 1)) * 100;

  return (
    <div className="container mt-5">
      <h2 className="mb-4">Edit Property</h2>

      <div className="progress mb-4">
        <div className="progress-bar" style={{ width: `${progressPercent}%` }}>
          Step {step} of {steps.length}
        </div>
      </div>

      <div className="card p-4">{renderStepComponent()}</div>
    </div>
  );
};

export default EditPropertyItem;